module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-t"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('em', [_vm._v("Published with the generous support of the Georgia Writers Hall of Fame")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by the University of Georgia Press"), _c('br'), _vm._v("\n  Athens, Georgia 30602"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.ugapress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ugapress.org")]), _c('br'), _vm._v("\n  © 2018 by Nicole Seitz and Jonathan Haupt"), _c('br'), _vm._v("\n  All rights reserved"), _c('br'), _vm._v("\n  Designed by Erin Kirk New"), _c('br'), _vm._v("\n  Set in 10.7 on 15 Minion Pro"), _c('br'), _vm._v("\n  Printed and bound by Thomson-Shore, Inc."), _c('br'), _vm._v("\n  The paper in this book meets the guidelines for permanence and durability of the Committee on Production Guidelines for Book Longevity of the Council on Library Resources.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Most University of Georgia Press titles are available from popular e-book vendors.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed in the United States of America"), _c('br'), _vm._v("\n  22  21  20  19  18  c  5  4  3  2  1")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Control Number: 2018018091"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN:")]), _vm._v(" 9780820354484 (hardcover: alk. paper)"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN:")]), _vm._v(" 9780820354491 (ebook)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60405216","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copy.vue
// module id = 66
// module chunks = 0